import actionConfig from "./actions";
import fileConfig from "./file";
import genericConfig from "./generic";
import sailorConfig from "./sailor";
import navigationConfig from "./navigation";
import applicationConfig from "./application";

const noteCategories = {
  kybNote: "kybNotes",
  kycAmlNote: "kycAmlNotes",
  idvNote: "idvNotes",
  creditReportNote: "creditReportNotes",
  affordabilityNote: "affordabilityNotes",
  creditSummaryNote: "creditSummaryNotes",
  vulnerabilityNote: "vulnerabilityNotes",
};

const collections = {
  application: "applications",
  dealer: "dealers",
  file: "files",
  sailorAddress: "sailorAddresses",
  sailor: "sailors",
  DealerRiskProfile: "dealerRiskProfiles",
};

const SaltCollection = {
  _current: "current",
  _action: "actions",
  AmlCheck: "amlChecks",
  Agreement: "agreements",
  Application: "applications",
  ApplicationSummary: "applicationsSummary",
  Application_AffordabilityReport: "affordabilityReport",
  Application_CreditReportNote: "creditReportNotes",
  Application_CreditUnderwriting: "creditUnderwriting",
  Boat: "boats",
  CreditCheck: "creditChecks",
  Dealer: "dealers",
  Sailor: "sailors",
  SailorRiskProfile: "sailorRiskProfiles",
  IdvCheck: "idvChecks",
  File: "files",
  OpenBanking: "openBanking",
};

const config = {
  ...actionConfig,
  ...fileConfig,
  ...genericConfig,
  ...sailorConfig,
  ...navigationConfig,
  ...applicationConfig,
  collections,
  SaltCollection,
  noteCategories,
};
export default config;
